import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

interface BiasSwitchProps {
  bias: 'long' | 'short';
  onBiasChange: (bias: 'long' | 'short') => void;
}

export const BiasSwitch: React.FC<BiasSwitchProps> = ({ bias, onBiasChange }) => {
  return (
    <div className="inline-flex items-center space-x-3 bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-lg p-2">
      <span className="text-sm text-gray-400 font-medium px-2">Trading Bias:</span>

      <div className="inline-flex rounded-lg bg-gray-900/50 p-1">
        <button
          onClick={() => onBiasChange('long')}
          className={`
            flex items-center space-x-2 px-4 py-2 rounded-md transition-all duration-200 text-sm font-semibold
            ${bias === 'long'
              ? 'bg-green-600 text-white shadow-lg shadow-green-600/30'
              : 'text-gray-400 hover:text-green-400 hover:bg-gray-800/50'
            }
          `}
        >
          <TrendingUp className="h-4 w-4" />
          <span>Long Bias</span>
        </button>

        <button
          onClick={() => onBiasChange('short')}
          className={`
            flex items-center space-x-2 px-4 py-2 rounded-md transition-all duration-200 text-sm font-semibold
            ${bias === 'short'
              ? 'bg-red-600 text-white shadow-lg shadow-red-600/30'
              : 'text-gray-400 hover:text-red-400 hover:bg-gray-800/50'
            }
          `}
        >
          <TrendingDown className="h-4 w-4" />
          <span>Short Bias</span>
        </button>
      </div>

      <div className={`
        px-3 py-1 rounded-full text-xs font-bold border-2
        ${bias === 'long'
          ? 'bg-green-500/10 text-green-400 border-green-500/30'
          : 'bg-red-500/10 text-red-400 border-red-500/30'
        }
      `}>
        {bias === 'long' ? 'LONG' : 'SHORT'}
      </div>
    </div>
  );
};
